'use client';

import React from 'react';
import LottieRender from './LottieRender';

const CultureProcess = () => {
    return (
        <section className="py-24 bg-slate-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-32">

                {/* 1. Culture Section */}
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl lg:text-4xl font-black text-slate-900 mb-6">
                            Cultivating <span className="text-indigo-600">Growth</span>
                        </h2>
                        <p className="text-lg text-slate-600 leading-relaxed">
                            Our culture is built on continuous learning and collaborative problem-solving. We believe that a happy, challenged team delivers the most innovative solutions.
                        </p>
                    </div>
                    <div className="h-[400px] w-full rounded-3xl bg-white shadow-lg overflow-hidden border border-slate-100 p-8">
                        {/* Your Journey.lottie */}
                        <LottieRender animationPath="/animations/culture_embedded.json" />
                    </div>
                </div>

                {/* 2. Process Section */}
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="order-2 lg:order-1 h-[400px] w-full rounded-3xl bg-white shadow-lg overflow-hidden border border-slate-100 p-8">
                        {/* maintenance_V3.lottie */}
                        <LottieRender animationPath="/animations/process_v2.json" />
                    </div>
                    <div className="order-1 lg:order-2">
                        <h2 className="text-3xl lg:text-4xl font-black text-slate-900 mb-6">
                            Precision <span className="text-indigo-600">Process</span>
                        </h2>
                        <p className="text-lg text-slate-600 leading-relaxed mb-6">
                            From ideation to deployment and maintenance, our workflow is rigorous yet agile.
                        </p>
                        <div className="grid grid-cols-2 gap-4">
                            {["Discovery", "Architecture", "Development", "Optimization"].map((step, i) => (
                                <div key={i} className="bg-white p-4 rounded-xl border border-slate-200 text-center font-semibold text-slate-800 shadow-sm">
                                    {step}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default CultureProcess;
